import styled from "styled-components";

const Container = styled.div`
  padding: 16px 16px 0 16px;
`;
const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0 16px 0; 
  border-bottom: 1px solid #f1f3f5;
`;

const InfoText = styled.p`
  font-size: 0.75rem;
  font-weight: regular;
  color: #878e95;
  display: flex;
  justify-content: center;
  align-items: center;

  .moreinfo-icon {
    display: inline-block;
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin-left: 2px;
  }

  .moreinfotext {
    width: 308px;
    height: 212px;
    display: none;
    margin-top: 8px;
    margin-left: 15px;
  }
  .morinfogroup:hover .moreinfotext {
    position: absolute;
    display: flex;
  }
`;

const BoldText = styled.span`
  font-weight: 700;
  color: ${({ color }) => color};
  span:first-child {
    color: #222529;
    font-weight: 400;
  }
`;

export { Info, InfoText, BoldText, Container };
